import { useEffect, useState } from "react";
import Modal from "@/components/common/Modal";
import Button from "@/components/common/Button";
import { useApp } from "@/contexts/AppContext";

// Admin-only: hand a campaign to another user (e.g. an agency account). The
// campaign keeps its money, statistics and settings; only the owner changes.
export default function TransferCampaignModal({ campaign, onClose }) {
  const { users, transferCampaign } = useApp();
  const [userUuid, setUserUuid] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setUserUuid("");
    setError(null);
  }, [campaign]);

  const candidates = users
    .filter((u) => u.uuid !== campaign?.userId)
    .sort((a, b) => a.username.localeCompare(b.username));
  const owner = users.find((u) => u.uuid === campaign?.userId);

  const handleTransfer = async () => {
    if (!campaign || !userUuid) return;
    setLoading(true);
    setError(null);
    try {
      await transferCampaign(campaign.uuid, userUuid);
      onClose();
    } catch (err) {
      setError(err.message || "Failed to transfer the campaign.");
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <>
      <Button variant="secondary" onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button onClick={handleTransfer} disabled={loading || !userUuid}>
        {loading ? "Transferring…" : "Transfer"}
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={Boolean(campaign)}
      onClose={onClose}
      title="Transfer campaign"
      size="medium"
      footer={footer}
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-(--text-secondary)">
          <strong>{campaign?.name}</strong> is owned by{" "}
          <strong>{owner?.username ?? "unknown"}</strong>. The new owner sees
          and edits it; its spend and statistics stay with the campaign.
        </p>
        <div className="form-group-modal">
          <label htmlFor="transfer-user">New owner</label>
          <select
            id="transfer-user"
            value={userUuid}
            onChange={(e) => setUserUuid(e.target.value)}
          >
            <option value="">Choose a user…</option>
            {candidates.map((u) => (
              <option key={u.uuid} value={u.uuid}>
                {u.username} ({u.role})
              </option>
            ))}
          </select>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    </Modal>
  );
}
